var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpiUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5165",
    "data-name": "Group 5165",
    transform: "translate(-601 -390)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(601 390)",
    fill: "#40aa77",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(607.24 395.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M.813,35.567a4.885,4.885,0,0,0,2.081,4,.4.4,0,0,1,.021.648l-.006,0a.4.4,0,0,1-.479.015A5.7,5.7,0,0,1,0,35.567a5.762,5.762,0,0,1,5.721-5.7v.813A4.948,4.948,0,0,0,.813,35.567Zm0,0",
    transform: "translate(0 -29.111)",
    fill: "#40aa77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M224.875.024l1.494,1.022a.138.138,0,0,1,0,.228L224.875,2.3a.138.138,0,0,1-.216-.114V.138a.138.138,0,0,1,.216-.114Zm0,0",
    transform: "translate(-219.005 0)",
    fill: "#40aa77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    d: "M235.466,71.8a4.886,4.886,0,0,0-2.081-4,.4.4,0,0,1-.021-.648l.006,0a.4.4,0,0,1,.479-.015,5.7,5.7,0,0,1,2.43,4.671,5.758,5.758,0,0,1-5.717,5.7v-.813a4.944,4.944,0,0,0,4.9-4.891Zm0,0",
    transform: "translate(-224.76 -65.365)",
    fill: "#40aa77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M164.256,422.1l-1.494-1.022a.138.138,0,0,1,0-.228l1.494-1.022a.138.138,0,0,1,.216.114v2.044A.138.138,0,0,1,164.256,422.1Zm0,0",
    transform: "translate(-158.606 -409.233)",
    fill: "#40aa77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    d: "M124.033,186.327l-2.448,2.03-.617.512a.807.807,0,0,1-1.162-.137l-.952-1.269a.649.649,0,0,1,1.039-.779l.643.857.005,0,2.664-2.209a.649.649,0,0,1,.829,1Zm0,0",
    transform: "translate(-115.736 -180.518)",
    fill: "#40aa77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    d: "M194.375,186.328l-2.448,2.03a3.288,3.288,0,0,1-1.044-.82l2.664-2.209a.649.649,0,0,1,.828,1Zm0,0",
    transform: "translate(-186.079 -180.518)",
    fill: "#40aa77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiUpdateIcon);
export default __webpack_public_path__ + "static/media/kpi-update-icon.279a0a1ec30ffdab045543ca12869af0.svg";
export { ForwardRef as ReactComponent };